export class TableLinkColumnDTO {
  linkColor: 'primary' | 'accent' | 'warn'
  linkText: string
  linkUrl: string
  linkData: string
  selected: boolean
}
